<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
        <h1> TERAS iDEAS CONVENTION 2023 </h1>
        <br><br>
        <v-btn
          color="orange"
          text
          outlined
          :href="downloadLink"
          target="_blank"
        >
          Download PDF
        </v-btn>
        <br><br>
      </v-col>
    </v-row>

    <v-col
        v-for="card in cards"
        :key="card.id"
        class="d-flex child-flex"
        cols="12"
      >
        <v-card>
          <v-img
          :src="card.src"
          :lazy-src="card.src"
          class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          
        </v-card>
        <br>
      </v-col>
    <br><br>
  
  </v-container>
</template>

<script>
export default {
  data: () => ({
    downloadLink:'https://teraslegacy.com/wp-content/uploads/2023/01/Teras-iDEAS-Convention-TIC-2023-v3.pdf',

    cards: [
      { 
        id: '1', 
        title: '1', 
        src: 'https://teraslegacy.com/wp-content/uploads/2023/01/TIC-2023-v3_page-0001.jpg', 
      },
      { 
        id: '2', 
        title: '2', 
        src: 'https://teraslegacy.com/wp-content/uploads/2023/01/TIC-2023-v3_page-0002.jpg', 
      },
      { 
        id: '3', 
        title: '3', 
        src: 'https://teraslegacy.com/wp-content/uploads/2023/01/TIC-2023-v3_page-0003.jpg',
      },
      { 
        id: '4', 
        title: '4', 
        src: 'https://teraslegacy.com/wp-content/uploads/2023/01/TIC-2023-v3_page-0004.jpg',
      },
      { 
        id: '5', 
        title: '5', 
        src: 'https://teraslegacy.com/wp-content/uploads/2023/01/TIC-2023-v3_page-0005.jpg',
      },
      { 
        id: '6', 
        title: '6', 
        src: 'https://teraslegacy.com/wp-content/uploads/2023/01/TIC-2023-v3_page-0006.jpg',
      },
    ],
  }),
}
</script>
